module.exports = __webpack_public_path__ + "media/npc_dota_hero_vengefulspirit.3e669adf.webm";